// @material-ui
import { makeStyles } from '@material-ui/styles'

export const currencyConverterStyle = theme => ({
  root: {
    flexGrow: 1,
  },

  content: {
    height: 'auto',
    paddingBottom: 0,
  },

  flip: {
    marginTop: theme.spacing(2),
  },

  timeLabel: {
    [`${theme.breakpoints.up('sm')}`]: {
      display: 'block',
    },

    [`${theme.breakpoints.up('lg')}`]: {
      display: 'inline',
    },
  },
})

export const useCurrencyConverterStyle = makeStyles(currencyConverterStyle)
